<script>

export default {
    render: function (createElement) {
        return createElement('style', this.value);
    },
    props: ['value']
}

</script>
